// import type { string, ISortHeaderStyleOption } from "../../ts-types";
// import { Style } from "./Style";

// let defaultStyle: SortHeaderStyle;
// export class SortHeaderStyle extends Style {

//   static get DEFAULT(): SortHeaderStyle {
//     return defaultStyle ? defaultStyle : (defaultStyle = new SortHeaderStyle());
//   }
//   constructor(style: ISortHeaderStyleOption = {}) {
//     super(style);

//   }

//   clone(): SortHeaderStyle {
//     return new SortHeaderStyle(this);
//   }
// }
